// extracted by mini-css-extract-plugin
export default {"Flex":"style_Flex__vhhYh","gap":"style_gap__YRtug","wrap":"style_wrap__-f2CF","center":"style_center__3QwW8"};